export const ACCOUNT_DISCONNECTED_MSG =
  "Account is temporarily disconnected. Please go to the 'Social Accounts' page to reconnect.";
export const POST_ACCOUNTS_SOME_DISCONNECTED =
  "Can't move disconnected account.";
export const CREATE_POST_ACCOUNTS_SOME_DISCONNECTED =
  "Remove disconnected account to save use this action";
